import { action, observable, runInAction } from 'mobx';
import { Tag } from '../models';
import { default as getRepository, TagRepository } from '../repositories/Tag';
import AsyncOperation from './AsyncOperation';

export class TagStore {
  public repository: TagRepository = getRepository();

  @observable
  public tags: Array<Tag> = [];

  @observable
  public fetchingTags: AsyncOperation<void> = AsyncOperation.resolved;

  @action
  public fetchTags = async (force: boolean = false): Promise<void> => {
    if (
      force ||
      !this.fetchingTags ||
      this.fetchingTags === AsyncOperation.resolved
    ) {
      runInAction(
        () => (this.fetchingTags = new AsyncOperation<void>(this._fetchTags()))
      );
    }

    return this.fetchingTags.promise;
  };

  public getTagById(tagId: number): Tag | undefined {
    const matchedTag = this.tags.find(tag => tag.id === tagId);

    return matchedTag;
  }

  public getTagByName(tagName: string): Tag | undefined {
    const matchedTag = this.tags.find(tag => tag.name === tagName);

    return matchedTag;
  }

  private _fetchTags = async (): Promise<void> => {
    const tags = await this.repository.fetchAll();

    runInAction(() => (this.tags = tags));
  };
}

export default TagStore;



// WEBPACK FOOTER //
// ./src/app/stores/TagStore.ts